import { useEffect } from "react";
import { useParams } from "react-router-dom";
export function useFetchAndReset(fetch, reset) {
    var id = useParams().id;
    useEffect(function () {
        if (id === "new") {
            return;
        }
        fetch(id);
        return reset;
    }, [id]);
}
//# sourceMappingURL=useFetchAndReset.js.map